import { GetArticleResponse } from "../modules/articles/interfaces/get-article";
import { GetArticlesResponse } from "../modules/articles/interfaces/get-articles";

export const productMapper = {
  mapResponseToProducts(response: GetArticleResponse): GetArticlesResponse {
    return {
      products: [response],
      pagination: {
        page: 1,
        size: 100,
        total_elements: 1,
      }
    };
  },
};